import BaseParseObject from './BaseParseObject'

'use strict'

export const ObservingStatusStatistics = BaseParseObject.extend(
    'ObservingStatusStatistics',
    {}
  )

export default ObservingStatusStatistics
